import {
  Button,
  Form,
  FormFeedback,
  Input,
  Modal,
  ModalBody,
} from "reactstrap";
import ResultHandler from "../../components/ResultHandler";
import { remove2Fa } from "../../api/auth";
import { useResponse } from "../../hooks/useResponse";
import { useFormik } from "formik";
import useCustomValidation from "../dashboard/validationSchema";

const Remove2FaModal = ({ show, setShow, refetch }) => {
  const { twoFactorVerificationSchema } = useCustomValidation();

  const handleClose = () => setShow(false);

  const { setData, error, loading } = useResponse(remove2Fa, () => {
    handleClose();
    refetch();
    localStorage.setItem("twoFactorEnabled", false);
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { code: "" },
    validationSchema: twoFactorVerificationSchema,
    onSubmit: (values) => {
      setData({ type: "add", data: { ...values } });
    },
  });

  return (
    <Modal isOpen={show} toggle={handleClose} centered={true}>
      <ModalBody className="p-4">
        <Form className="form-horizontal" onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <h5
              style={{
                fontSize: "17px",
                fontWeight: "600",
                borderLeft: "3px solid",
                paddingLeft: "10px",
                marginBottom: "16px",
              }}
            >
              Enter Verification Code
            </h5>
            <Input
              name="code"
              className="form-control"
              type="text"
              placeholder="Verification code"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.code || ""}
              invalid={formik.touched.code && formik.errors.code ? true : false}
            />
            {formik.touched.code && formik.errors.code ? (
              <FormFeedback type="invalid">{formik.errors.code}</FormFeedback>
            ) : null}
          </div>

          <p style={{ fontWeight: "600" }} className="">
            Enter the code from your two-factor authintication app.
          </p>

          <ResultHandler error={error} />

          <div className="d-flex gap-2 flex-row-reverse">
            <Button
              color="danger"
              type="submit"
              disabled={loading}
              className="fw-bold"
            >
              {loading ? "Loading..." : "Remove"}
            </Button>
            <Button
              color="primary"
              type="button"
              disabled={loading}
              className="fw-bold"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default Remove2FaModal;
